import { VALID_URL_REGEXP } from '../../../utils/url-utils';

export const isNumeric = (arg: unknown) => !Number.isNaN(Number(arg));

export const hasNumber = (myString: string) => /\d/.test(myString);

export type DuplicateCheckResult =
  | { hasDuplicates: true; duplicateValue: string; originalIndex: number; duplicateIndex: number }
  | { hasDuplicates: false };

export const hasDuplicates = (array: (string | null)[]): DuplicateCheckResult => {
  const valuesSoFar: Record<string, number> = Object.create(null);

  for (let i = 0; i < array.length; ++i) {
    const value = array[i];
    const key = String(value);
    if (value !== null && key in valuesSoFar) {
      return {
        hasDuplicates: true,
        duplicateValue: value,
        originalIndex: valuesSoFar[key],
        duplicateIndex: i
      };
    }
    valuesSoFar[key] = i;
  }

  return { hasDuplicates: false };
};

export const addInvalidClass = (selector: string, selectorType: string) => {
  switch (selectorType) {
    case 'class':
      if (!document.getElementsByClassName(selector)[0]?.classList.contains('invalid')) {
        document.getElementsByClassName(selector)[0]?.classList.add('invalid');
      }
      break;
    default:
      // default selector type is id
      if (!document.getElementById(selector)?.classList.contains('invalid')) {
        document.getElementById(selector)?.classList.add('invalid');
      }
  }
};

export const removeInvalidClass = (selector: string, selectorType: string) => {
  switch (selectorType) {
    case 'class':
      if (document.getElementsByClassName(selector)[0]?.classList.contains('invalid')) {
        document.getElementsByClassName(selector)[0]?.classList.remove('invalid');
      }
      break;
    default:
      // default selector type is id
      if (document.getElementById(selector)?.classList.contains('invalid')) {
        document.getElementById(selector)?.classList.remove('invalid');
      }
  }
};

export const getFormFieldIndex = (invalidationArray: string | any[], formFieldName: string) =>
  invalidationArray.indexOf(formFieldName);

export const getUtmKeySegment = (key: string): string => {
  if (key.indexOf('_') === -1) return key;
  return key === 'cki_replace_key' ? key.split('_')[2] : key.split('_')[1];
};

export const isValidUrl = (url: string) => {
  const testQuestionMark = /.+\?/;
  return (
    Boolean(VALID_URL_REGEXP.test(url)) &&
    !testQuestionMark.test(url) &&
    url.indexOf('https://') !== -1 &&
    (url.match(/\./g) || []).length >= 1
  );
};
